















import Vue from 'vue'
import { mapActions } from 'vuex'

export default Vue.extend({
  props: {
    value: {
      required: true,
      type: Object,
    },
  },
  methods: {
    ...mapActions('interview/bookings', ['book']),
  },
})
